import React, { createContext, useState } from "react";
import Aunty from "./Aunty/Aunty";
import Father from "./Father/Father";
import "./Grandpa.css";
import Uncle from "./Uncle/Uncle";
export const RingContext = createContext("Diamond Ring");
export const MoneyContext = createContext(555);

const Grandpa = () => {
  const [house, setHouse] = useState(1);
  const [money, setMoney] = useState(100);

  return (
    <RingContext.Provider value={[house, setHouse]}>
      <MoneyContext.Provider value={[money, setMoney]}>
        <div className="grandpa">
          <h4>Grandpa</h4>
          <section className="flex">
            <Father house={house}></Father>
            <Uncle house={house}></Uncle>
            <Aunty house={house}></Aunty>
          </section>
        </div>
      </MoneyContext.Provider>
    </RingContext.Provider>
  );
};

export default Grandpa;
